<div class="frame-2126">
    <div class="site-title" *ngIf="!isFavouriteScreen">
        <a 
            #siteAnchorLink
            [tabIndex]="0"                    
            [autofocus]="true"
            (click)="onSitelinkClicked(sitePopupInfo?.Identifier)"
            [routerLink]="['/siteDetails', sitePopupInfo?.Identifier]">
            <span class="text">{{sitePopupInfo?.SiteName ?? ""}}</span>
        </a>  
        <div *ngIf="closable">
            <button [tabIndex]="0" class="button-close" (click)="onCloseButtonClicked($event)"></button>
        </div>            
    </div>

    <img *ngIf="isFavouriteScreen && showScreenshot" 
        class="screenshot" [src]="siteImage" [alt]="sitePopupInfo?.SiteName ?? ''">

    <div class="frame-2097">
        <span class="title">Today</span>
    </div> 

    <div class="frame-2128">
        <div class="frame-2127">
            <div class="wq-v2-mobile">
                <div [class]="wrapperClass">
                    <div class="frame-2123">
                        <div [class]="titleBlockClass">
                            <span [class]="titleBlockClass + '__title'">{{forecastBriefDesc}}</span>
                        </div>
                        <div class="last-updated">
                            <app-last-updated-widget *ngIf="sitePopupInfo?.PollForecastDateTime"
                                [label]="'Last updated'" 
                                [updatedDate]="lastUpdatedDate"
                                dateOutFormat="EE, d/M, h aaaaa'm''">
                            </app-last-updated-widget>
                        </div>
                        <div class="frame-2122">
                            <img class="icon" 
                            [src]="'assets/images/WaterqualityForecastIndicator/' + pollLevelIndicatorIcon">                                
                            <span class="text">{{pollutionForecastText}}</span>
                        </div>
                    </div>
                    <div class="frame-2125">
                        <span class="text">
                            {{sitePopupInfo?.PollutionDescription ?? ""}}                       
                        </span>
                    </div>       
                </div>
            </div>
           
        </div>        

        <div class="weather-area-popup">
            <div class="frame-2079">
                <div class="detail-frame">                                               
                    <img class="weather-icon item" src="assets/images/WeatherIcons/sunny.svg">
                    <span class="weather-title-text item">Weather</span>
                    <span class="weather-value-text item">{{sitePopupInfo?.WeatherForecast?.AirTemp ? 
                        sitePopupInfo?.WeatherForecast?.AirTemp + '&#xB0;' : '&nbsp;'}}
                    </span>
                    <span class="weather-desc-text item">{{sitePopupInfo?.WeatherForecast?.PrecisForecast?.toString() ?? ""}}</span>
                </div>                    
                
                <div class="vertical-divider item"></div>
                
                <div class="detail-frame">                        
                    <img class="weather-icon item" src="assets/images/WeatherIcons/rain.svg">
                    <span class="weather-title-text item">Rainfall</span>
                    <span class="weather-value-text item">{{sitePopupInfo?.WeatherForecast?.RainfallAmount ? 
                        sitePopupInfo?.WeatherForecast?.RainfallAmount?.toString() : '&nbsp;'}}
                    </span>
                    <span class="weather-desc-text item">{{sitePopupInfo?.WeatherForecast?.RainfallChance ? 
                        sitePopupInfo?.WeatherForecast?.RainfallChance?.toString() : '&nbsp;'}}
                    </span>
                </div>                    
                
                <div class="vertical-divider item"></div> 
                
                <div class="detail-frame">                        
                    <img class="weather-icon item" src="assets/images/WeatherIcons/windy.svg">
                    <span class="weather-title-text item">Wind</span>
                    <span class="weather-value-text item">{{sitePopupInfo?.WeatherForecast?.WindSpeedKmh ? 
                        sitePopupInfo?.WeatherForecast?.WindSpeedKmh?.toString() + "km/h" : '&nbsp;'}}
                    </span>
                    <span class="weather-desc-text item">{{sitePopupInfo?.WeatherForecast?.WindDir ? 
                        (sitePopupInfo?.WeatherForecast?.WindDir | uppercase) : '&nbsp;'}}
                    </span>
                </div>                    
            </div>

            <div class="horizontal-divider"></div>
            
            <div class="frame-2134" >

                <div class="frame-2081">
                    <ng-container *ngIf="!!sitePopupInfo?.ShowTide">
                        <div class="tide-detail-frame">
                            <img class="weather-icon" src="assets/images/WeatherIcons/tide.svg">
                            <div class="weather-title-text">Tide</div> 
                        </div>
                        <div class="frame-2138">
                            <div class="tide-info-block">
                                <span class="weather-value-text">High</span>
                                <span class="weather-desc-text text-nowrapping">
                                    {{
                                        sitePopupInfo?.WeatherForecast?.NextTideHighTime ? 
                                        (getLocalDateTime(sitePopupInfo?.WeatherForecast?.NextTideHighTime!) | date:"hh:mm aa" | lowercase) : '&nbsp;'
                                    }}
                                </span>
                                <span class="weather-desc-text text-nowrapping">
                                    {{
                                        sitePopupInfo?.WeatherForecast?.NextTideHighHeight ? 
                                        sitePopupInfo?.WeatherForecast?.NextTideHighHeight?.toString() + " m": '&nbsp;'
                                    }}
                                </span>
                            </div>
                            <div class="tide-info-block">
                                <span class="weather-value-text">Low</span>
                                <span class="weather-desc-text text-nowrapping">
                                    {{
                                        sitePopupInfo?.WeatherForecast?.NextTideLowTime ? 
                                        (getLocalDateTime(sitePopupInfo?.WeatherForecast?.NextTideLowTime!) | date:"hh:mm aa" | lowercase) : '&nbsp;'
                                    }}
                                </span>
                                <span class="weather-desc-text text-nowrapping">
                                    {{
                                        sitePopupInfo?.WeatherForecast?.NextTideLowHeight ? 
                                        sitePopupInfo?.WeatherForecast?.NextTideLowHeight?.toString() + " m": '&nbsp;'
                                    }}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                    
                </div>

                <div class="vertical-divider"></div>

 
                <div class="swell-detail-frame">
                    <ng-container *ngIf="!!sitePopupInfo?.ShowSwell">
                        <img class="weather-icon item" src="assets/images/WeatherIcons/swell.svg" alt="swell">
                        <div class="weather-title-text item">Swell</div> 
                        <span class="weather-value-text item">
                            {{sitePopupInfo?.WeatherForecast?.SwellHeight ? 
                                (sitePopupInfo?.WeatherForecast?.SwellHeight + "m") : '&nbsp;'}}
                        </span>
                        <span class="weather-desc-text item">
                            {{
                                sitePopupInfo?.WeatherForecast?.SwellDirection ? 
                                (sitePopupInfo?.WeatherForecast?.SwellDirection) : ""
                            }}
                        </span> 
                    </ng-container>                    
                </div>
            </div>                
        </div>    
    </div>
    
    <div class="weekly-rating">
        <div class="latest-result-container">
            <app-last-updated-widget class="last-updated-container" 
                [alignPillRight]="isFavouriteScreen"
                [label]="'Latest result'" 
                [updatedDate]="sitePopupInfo?.LatestResultDate"
                [dateOutFormat]="'dd/LL/yyyy'"
                [labelBold]="true"
                [tagColourNSWDark]="true">
            </app-last-updated-widget>    
        </div>
        <div class="star-rating-container">
            <app-site-rating 
                *ngIf="sitePopupInfo?.LatestResultStarRating" 
                [rating]="sitePopupInfo?.LatestResultStarRating">
            </app-site-rating> 
        </div>
        <span class="text">Based on actual samples</span>
    </div>
</div>
